import React, { useEffect, useState } from "react";
import { Gauge } from "lucide-react";
import api, { apiErr } from "@/lib/api";
import { toast } from "sonner";

export default function IopFormulaSettings() {
  const [cfg, setCfg] = useState(null);
  const [refCct, setRefCct] = useState("");
  const [coeff, setCoeff] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/medico/iop-correction").then(({ data }) => {
      setCfg(data);
      if (data?.configured) { setRefCct(String(data.reference_cct)); setCoeff(String(data.coeff_per_10um)); }
    }).catch(() => {});
  }, []);
  const save = async () => {
    const r = parseFloat(String(refCct).replace(",", "."));
    const k = parseFloat(String(coeff).replace(",", "."));
    if (isNaN(r) || isNaN(k)) { toast.error("Inserisci CCT di riferimento (µm) e coefficiente (mmHg/10µm)"); return; }
    setSaving(true);
    try {
      const { data } = await api.put("/medico/iop-correction", { reference_cct: r, coeff_per_10um: k });
      setCfg(data);
      toast.success(`Formula tono corretto salvata (v${data.version})`);
    } catch (e) { toast.error(apiErr(e, "Errore salvataggio formula")); } finally { setSaving(false); }
  };

  return (
    <div className="bg-white border border-[#E2E8F0] rounded-xl p-4" data-testid="iop-formula-settings">
      <div className="flex items-center gap-2 mb-2">
        <Gauge size={15} className="text-brand-azure" />
        <h3 className="font-extrabold text-brand-navy text-sm">Tono corretto da pachimetria (stima indicativa)</h3>
        {cfg?.configured && (
          cfg.source === "system_default" ? (
            <span className="text-[10px] uppercase tracking-wider bg-slate-100 text-slate-600 border border-slate-200 px-2 py-0.5 rounded font-bold" data-testid="iop-settings-version">
              Default di sistema (v0)
            </span>
          ) : (
            <span className="text-[10px] uppercase tracking-wider bg-emerald-50 text-emerald-700 border border-emerald-200 px-2 py-0.5 rounded font-bold" data-testid="iop-settings-version">
              v{cfg.version} personalizzata
            </span>
          )
        )}
      </div>
      <p className="text-xs text-slate-500 mb-3">
        Correzione = tono + ((CCT riferimento − CCT misurata)/10) × coefficiente. La misura IOP non viene mai modificata;
        la stima (sempre &quot;indicativa&quot;) appare automaticamente in cartella quando tono e pachimetria sono compilati.
        Default di sistema: CCT 550 µm · 0,5 mmHg/10µm — salvando qui crei la tua versione personalizzata, versionata e auditabile.
      </p>
      <div className="flex flex-wrap items-end gap-3">
        <div>
          <label className="text-[10px] font-bold uppercase tracking-wider text-slate-500">CCT riferimento <span className="normal-case">(µm)</span></label>
          <input data-testid="iop-settings-refcct" value={refCct} onChange={(e) => setRefCct(e.target.value)} inputMode="decimal"
            placeholder="es. 545" className="mt-1 block w-36 px-2 py-1.5 rounded-lg border border-[#E2E8F0] text-xs bg-white focus:outline-none focus:border-brand-azure" />
        </div>
        <div>
          <label className="text-[10px] font-bold uppercase tracking-wider text-slate-500">Coefficiente <span className="normal-case">(mmHg / 10 µm)</span></label>
          <input data-testid="iop-settings-coeff" value={coeff} onChange={(e) => setCoeff(e.target.value)} inputMode="decimal"
            placeholder="es. 0.3" className="mt-1 block w-36 px-2 py-1.5 rounded-lg border border-[#E2E8F0] text-xs bg-white focus:outline-none focus:border-brand-azure" />
        </div>
        <button type="button" data-testid="iop-settings-save" onClick={save} disabled={saving}
          className="px-4 py-2 rounded-lg bg-brand-navy text-white text-xs font-bold disabled:opacity-60 hover:bg-brand-azure transition">
          {saving ? "Salvo…" : "Salva formula"}
        </button>
      </div>
    </div>
  );
}
